"use strict";

const InputBaseControlComponent = require("../InputBaseControlComponent");
const _ = require("lodash");

class InputBaseTextfieldControlComponent extends InputBaseControlComponent {
    /**
     * @schema.name Input Base Textfield Control
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default ""
     * @schema.configuration.placeholder.required false
     *
     * @schema.configuration.value.name value
     * @schema.configuration.value.type string
     * @schema.configuration.value.default ""
     * @schema.configuration.value.required false
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._DEFAULT_PLACEHOLDER = "";
        this._value = _.get(configOptions, "value", "");
        this._placeholder = _.get(configOptions, "placeholder", this._DEFAULT_PLACEHOLDER);
    }
    /*******************************************/
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setPlaceholder.name setPlaceholder
     * @schema.methods.setPlaceholder.description Sets the placeholder text and returns an instance of the control for chainability
     * @schema.methods.setPlaceholder.returns Instance of the control
     * @schema.methods.setPlaceholder.parameters.newVal.name newVal
     * @schema.methods.setPlaceholder.parameters.newVal.description The new placeholder text
     * @schema.methods.setPlaceholder.parameters.newVal.type string
     */
    setPlaceholder(newVal) {
        if (newVal === undefined || newVal === null || newVal === "") {
            this._placeholder = this._DEFAULT_PLACEHOLDER;
        } else {
            this._placeholder = newVal;
        }
        this.emit("Placeholder", this._placeholder);
        return this;
    }
    /**
     * @schema.methods.getPlaceholder.name getPlaceholder
     * @schema.methods.getPlaceholder.description Returns the placeholder text
     * @schema.methods.getPlaceholder.returns string
     */
    getPlaceholder() {
        return this._placeholder;
    }
    get placeholder() {
        return this.getPlaceholder();
    }
    set placeholder(newVal) {
        return this.setPlaceholder(newVal);
    }

    /**
     * @schema.methods.setValue.name setValue
     * @schema.methods.setValue.description Sets the value and returns an instance of the control for chainability
     * @schema.methods.setValue.returns Instance of the control
     * @schema.methods.setValue.parameters.newVal.name newVal
     * @schema.methods.setValue.parameters.newVal.description The new value
     * @schema.methods.setValue.parameters.newVal.type string
     * @schema.methods.setValue.parameters.wasTriggeredByUser.name wasTriggeredByUser
     * @schema.methods.setValue.parameters.wasTriggeredByUser.description Flag alerting that this was a user-triggered change (optional)
     * @schema.methods.setValue.parameters.wasTriggeredByUser.required false
     * @schema.methods.setValue.parameters.wasTriggeredByUser.type boolean
     */
    setValue(newVal, wasTriggeredByUser) {
        let oldVal = _.cloneDeep(this._value);
        this._value = newVal;
        this.emit("Value", this._value, oldVal, wasTriggeredByUser);
        return this;
    }
    /**
     * @schema.methods.getValue.name getValue
     * @schema.methods.getValue.description Returns the value of the control
     * @schema.methods.getValue.returns string
     */
    getValue() {
        return this._value;
    }
    get value() {
        return this.getValue();
    }
    set value(newVal) {
        return this.setValue(newVal);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = InputBaseTextfieldControlComponent;
